import {Component, OnInit} from '@angular/core';
import {StateService} from "@uirouter/core";

import {
    ParametersService,
    SubtitlesService,
    ViewsService,
    ZonesService
} from "../../core";
import {ZoneData} from "../../models";

@Component({
    selector: 'zone-info',
    templateUrl: './zone-info.component.html',
    styleUrls: ['./zone-info.component.scss']
})
export class ZoneInfoComponent implements OnInit {
    zone!: ZoneData;

    constructor(
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public views: ViewsService,
        public zones: ZonesService,
    ) {
    }

    ngOnInit() {
        if (this.zones.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }
        this.zone = this.zones.selectedZone as ZoneData;
        this.zones.setOverflow();
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }
}
